if (!window._babelPolyfill) {
  require('babel-polyfill');
}
import angular from 'angular';
import $ from 'jquery';
import 'angular-sanitize';
import '../../../scripts/adfox.asyn.code.ver3.js';
import adfox from '@cian/adfox/build/angular';

// Шрифты
const ui = [
  require('@cian/ui/app/components/button/index.jsm').default,
  require('@cian/ui/app/components/input-wrapper/index.jsm').default,
  require('@cian/ui/app/components/radio-wrapper/index.jsm').default,
  require('@cian/ui/app/components/checkbox-wrapper/index.jsm').default,
  require('@cian/ui/app/components/tooltip/index.jsm').default,
  require('@cian/ui/app/components/modal/index.jsm').default,
  require('@cian/ui/app/components/scroll-width/index.jsm').default,
  require('@cian/ui/app/components/preloader/index.jsm').default,
  require('@cian/ui/app/components/ruble/index.jsm').default,
  require('@cian/ui/app/components/typeahead/index.jsm').default,
  require('@cian/ui/app/components/icon/index.jsm').default,
  require('@cian/ui/app/components/tag/index.jsm').default,
  require('@cian/ui/app/components/email-subdomain-validator/index.jsm').default,
];

// некоторые модули зависят от ui.cian
const cianUi = angular.module('ui.cian', ui).name;

import declareCianSentryConfiguration from '@cian/sentry';
import { calculateEnvironmentByHost } from '@cian/utils/lib/shared/calculate_environment_by_host';

declareCianSentryConfiguration({
  dsn: '//23dfcf9d35554b0f9baea7919ec16553@sentry-front.cian.ru/10',
  release: process.env.SENTRY_RELEASE || 'local',
  environment: calculateEnvironmentByHost(window.location.host),
  matchUrl: url => {
    return [
      /\/static\/newbuild/,
      /\/static\/components\/region-browser/,
      /\/static\/components\/serp/,
    ].some(re => re.test(url));
  }
});

// adBlock у некоторых пользователей блокирует скрипт sentry.cian.site/sentry.min.js,
// поэтому в window может не быть Raven
if (window.Raven) {
  window.Raven
    // require работает, потому что в node_modules есть raven-js от @cian/sentry
    // TODO надо решать это на уровне @cian/sentry
    .addPlugin(require('raven-js/plugins/angular'), angular)
    .install();
}

import aload from 'aload';
$(() => {
  aload();
});

// css
import '../../../stylesheets/common.css';
import '../../../stylesheets/objects.css';
import '../../../stylesheets/popups.css';
import '../../../stylesheets/notifications.css';
import '../../../stylesheets/fotorama_4.6.4.1.css';


import '../../../components/ui/src/ui.less';
const req = require.context('../../../components/ui/src', true, /\.js$/);
req.keys().forEach(path => req(path));

import './serp.less';

import '../../../components/cian/src/scripts/user_service.js';

import '../components/highways-service/src/scripts/cian.highwaysService.js';

import '../components/geo-service/src/scripts/cian.geoService.js';
import '../components/geo-service/src/scripts/cian.geoUtils.js';
import '../components/geo-service/src/scripts/cian.geoSearch.js';
import '../components/geo-service/src/scripts/cian.geoApi.js';
import '../components/geo-service/src/scripts/cian.geoSuggest.js';

import '../../../scripts/autocomplete.js';

import '../components/geo-input/src/scripts/cian.geo-input.js';
import '../components/geo-input/src/scripts/cian.geo-input.ctrl.js';
import '../components/geo-input/src/scripts/cian.geo-input.dir.js';
import '../components/geo-input/src/styles/cian.geo-input.less';

import '../components/region-city-browser/src/scripts/cian.region-city-browser.js';

import '../components/deal-type-browser/src/scripts/cian.deal-type-browser.js';
import '../components/deal-type-browser/src/scripts/cian.deal-type-browser.dir.js';

import '../components/offer-type-browser/src/scripts/cian.offer-type-browser.js';
import '../components/offer-type-browser/src/scripts/cian.offer-type-browser.dir.js';

import '../components/rooms-browser/src/scripts/cian.rooms-browser.js';
import '../components/rooms-browser/src/scripts/cian.rooms-browser.dir.js';

import '../components/district-browser/src/scripts/cian.district-browser.js';
import '../components/district-browser/src/scripts/cian.district-browser.service.js';
import '../components/district-browser/src/scripts/cian.district-browser.ctrl.js';
import '../components/district-browser/src/scripts/cian.district-browser.dir.js';
import '../components/district-browser/src/styles/cian.district-browser.less';

import '../components/advanced-browser/src/scripts/cian.advanced-browser.js';
import '../components/advanced-browser/src/scripts/cian.advanced-browser.service.js';
import '../components/advanced-browser/src/scripts/cian.advanced-browser.popup.ctrl.js';
import '../components/advanced-browser/src/scripts/cian.advanced-browser.dir.js';
import '../components/advanced-browser/src/scripts/cian.advanced-filters.dir.js';
import '../components/advanced-browser/src/scripts/cian.advanced-browser-section.dir.js';
import '../components/advanced-browser/src/styles/cian.advanced-browser.less';

import '../components/highway-browser/src/scripts/cian.highway-browser.js';
import '../components/highway-browser/src/scripts/cian.highway-browser.ctrl.js';
import '../components/highway-browser/src/scripts/cian.highway-browser.dir.js';
import '../components/highway-browser/src/styles/cian.highway-browser.less';

import '../components/metro-browser/src/scripts/cian.metro-browser.js';
import '../components/metro-browser/src/scripts/cian.metro-browser.ctrl.js';
import '../components/metro-browser/src/scripts/cian.metro-svg-browser.ctrl.js';
import '../components/metro-browser/src/scripts/cian.metro-browser.dir.js';
import '../components/metro-browser/src/scripts/cian.metro-svg-browser.shadow.dir.js';
import '../components/metro-browser/src/scripts/cian.metro-svg-browser.station.dir.js';
import '../components/metro-browser/src/scripts/cian.metro-svg-browser.line.dir.js';
import '../components/metro-browser/src/scripts/cian.metro-svg-browser.change.dir.js';
import '../components/metro-browser/src/styles/cian.metro-browser.less';
import '../components/metro-browser/src/styles/cian.metro-svg-browser.less';

import '../components/map-draw/src/scripts/cian.map-draw.js';
import '../components/map-draw/src/scripts/cian.map-draw.service.js';
import '../components/map-draw/src/scripts/cian.map-draw.ctrl.js';
import '../components/map-draw/src/scripts/cian.map-draw.dir.js';
import '../components/map-draw/src/styles/cian.map-draw.less';

import '../components/filter-tag/src/scripts/cian.filter-tag.js';
import '../components/filter-tag/src/scripts/cian.filter-tag.dir.js';
import '../components/filter-tag/src/scripts/cian.filter-tags.dir.js';
import '../components/filter-tag/src/styles/cian.filter-tag.less';

import '../components/metro-distance/src/scripts/cian.metro-distance.js'
import '../components/metro-distance/src/scripts/cian.metro-distance.dir.js'
import '../components/metro-distance/src/styles/cian.metro-distance.less'

import '../../../components/debounce/src/scripts/cian.debounce.js';

import 'angular-animate';
import 'angular-i18n/angular-locale_ru.js';

// Filter
import '../components/filter/src/scripts/cian.filter.js';
import '../components/filter/src/scripts/cian.filter.object-type.service.js';
import '../components/filter/src/scripts/cian.filter.service.js';
import '../components/filter/src/scripts/cian.filter.ctrl.js';
import '../components/filter/src/scripts/cian.filter-terms.service.js';
import '../components/filter/src/scripts/cian.filter.converter.service.js';
import '../components/filter/src/styles/cian.filter.less';

import '../../../components/serp/src/scripts/popup.js';
import '../../../components/serp/src/scripts/cian.serp.js';
import '../../../components/serp/src/scripts/cian.serp.compileHtmlContent.js';
import '../../../components/serp/src/scripts/cian.serp.list.js';
import '../../../components/serp/src/scripts/cian.serp.listService.js';
import '../../../components/serp/src/scripts/cian.offer.services.js';
import '../../../components/serp/src/scripts/cian.serp.item.js';
import '../../../components/serp/src/scripts/cian.serp.item.premium_store.js';
import '../../../components/serp/src/scripts/cian.serp.item.noteEditor.js';
import '../../../components/serp/src/scripts/cian.serp.item.menu.js';
import '../../../components/serp/src/scripts/cian.serp.item.complainer.js';
import '../../../components/serp/src/scripts/cian.serp.item.rating.js';
import '../../../components/serp/src/scripts/cian.serp.item.statuses.js';
import '../../../components/serp/src/scripts/cian.serp.item.serpItemJquery.js';
import '../../../components/serp/src/scripts/serp_item.js';
import '../../../components/serp/src/styles/cian.serp.less';

import api from './services/api.service';
import stats from './services/stats.service.provider';
import analytics from './services/analytics.service';
import state from './services/state.service';
import scrollService from './services/scroll.service';

import agentBonusTooltip from '../components/agent-bonus/agent-bonus-tooltip';

angular.module('cian.newbuild.serp', [
  require('./controllers/serp-list-header').default,
  require('./directives/subscribe/subscribe.dir').default,
  require('./directives/serp-empty/serp-empty.dir').default,
  require('./directives/promote-tablet-version/promote-tablet-version.dir').default,
  require('./services/metro.service.js').default,
  require('./services/serp-view-mode.service').default,
  agentBonusTooltip.name,
  state,
  api,
  stats,
  analytics,
  scrollService,
  require('../common/feedback/index').default,
]);

angular.module('cian.newbuild.filter', [
  cianUi,
  require('./services/save-search/save-search.service').default,
  require('./services/filter-diff.service').default,
  require('./services/filter-tags.service').default,
  require('./services/tag-title/tag-title.service.js').default,
  require('./services/filter-sort.service').default,
  require('./services/available-filters/available-filters.service.js').default,
  require('./services/quick-filters.service.js').default,
  require('./services/region-ids.service').default,
  require('./services/meta.service').default,
  require('./services/browser-info.service').default,
  require('./services/filter-backup.service').default,
  require('./services/region-utils.service').default,
  require('./services/show-offers.service').default,
  state,
  api,
  analytics,
  scrollService,
  adfox.moduleName,
  // Директивы
  require('./directives/phone-parser.dir').default,
  require('./directives/range/range.dir').default,
  require('./directives/aload.dir').default,
  require('./directives/limit-number.dir').default,
  require('./directives/show-offers-button/show-offers-button.dir').default,
  require('./directives/filter-guide/filter-guide.dir').default,
  require('./directives/typeahead-with-tags/typeahead-with-tags.dir').default,
  require('./directives/offers-counter/offers-counter.dir').default,
  require('./directives/subscription-modal/subscription-modal.dir').default,
  require('./directives/sticky-filters.dir').default,
  require('./directives/serp-filter-associated-objects/serp-filter-associated-objects.dir').default,
  // Фильтры
  require('./filters/direction.filter').default,
  require('./filters/upper-first.filter').default,
]);



// WEBPACK FOOTER //
// ./src/serp/serp.js